import { motion } from 'framer-motion';

interface Feature {
  icon: string;
  title: string;
  desc: string;
}

interface ServiceFeaturesProps {
  features: Feature[];
}

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 28, scale: 0.97 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.45, ease: [0.25, 0.46, 0.45, 0.94] } },
};

export default function ServiceFeatures({ features }: ServiceFeaturesProps) {
  return (
    <section className="py-24 lg:py-32 bg-[#2d3139]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.05 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7"
        >
          {features.map((f, i) => (
            <motion.div
              key={i}
              variants={cardVariants}
              whileHover={{ y: -5, transition: { duration: 0.15, ease: 'easeOut' } }}
              className={`group relative p-8 rounded-[20px] flex flex-col gap-4 overflow-hidden cursor-default
                ${i % 2 === 0
                  ? 'bg-[rgba(255,255,255,0.07)] backdrop-blur-md border border-[rgba(255,255,255,0.12)]'
                  : 'bg-[#0f1419]'}
                hover:shadow-[0_8px_30px_rgba(0,212,255,0.15)] transition-shadow duration-200`}
            >
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-[#00d4ff] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[rgba(0,212,255,0.18)] shrink-0">
                <i className={`${f.icon} text-[#00d4ff] text-2xl`}></i>
              </div>
              <h3 className="text-white text-lg font-bold">{f.title}</h3>
              <p className="text-[rgba(255,255,255,0.6)] text-sm leading-relaxed">{f.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
